import { css } from '@emotion/react';
import type { ReactElement } from 'react';
import { Inline } from '~/_shared/baseComponents/layout/inline.component';
import {
  TooltipBehavior, TooltipComponent,
} from '~/_shared/baseComponents/tooltip/tooltip.component';
import { LimitNumberOfLinesComponent } from '~/_shared/components/limitNumberOfLines/limitNumberOfLines.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';

const inlineStyle = css({
  alignItems: 'center',
  justifyContent: 'space-between',
});

const headingStyle = (theme: Theme) => css({
  color: theme.textColors.info,
  fontSize: 15,
  textTransform: 'uppercase',
});

type OneDimensionalTableHeaderProps = Readonly<{
  value: string;
  auxiliaryElement?: ReactElement;
}>;

export const OneDimensionalTableHeader = ({ value, auxiliaryElement, ...restProps }: OneDimensionalTableHeaderProps) => {
  const [t] = useTranslation();
  const text = value || t('Empty');

  return (
    <Inline
      wrap="nowrap"
      css={inlineStyle}
      {...restProps}
      gap={4}
      data-element="one-dimensional-table-header-wrapper"
    >
      <TooltipComponent
        tooltipContent={text}
        behavior={TooltipBehavior.ShowOnOverflow}
      >
        <LimitNumberOfLinesComponent
          maxNumberOfLines={3}
          data-element="one-dimensional-table-header"
          css={headingStyle}
        >
          {text}
        </LimitNumberOfLinesComponent>
      </TooltipComponent>
      {auxiliaryElement}
    </Inline>
  );
};
